import { apiClient } from "./client";
import type {
  JobConfig,
  JobConfigUpdate,
  JobRun,
  JobRunDetail,
  JobRunListResponse,
} from "./types";

export async function listJobs(slug: string): Promise<JobConfig[]> {
  const res = await apiClient.get<JobConfig[]>(
    `/projects/${slug}/engine/jobs`,
  );
  return res.data;
}

export async function getJob(
  slug: string,
  jobId: string,
): Promise<JobConfig> {
  const res = await apiClient.get<JobConfig>(
    `/projects/${slug}/engine/jobs/${jobId}`,
  );
  return res.data;
}

export async function updateJob(
  slug: string,
  jobId: string,
  payload: JobConfigUpdate,
): Promise<JobConfig> {
  const res = await apiClient.patch<JobConfig>(
    `/projects/${slug}/engine/jobs/${jobId}`,
    payload,
  );
  return res.data;
}

export async function triggerJob(
  slug: string,
  jobId: string,
): Promise<JobRun> {
  const res = await apiClient.post<JobRun>(
    `/projects/${slug}/engine/jobs/${jobId}/trigger`,
  );
  return res.data;
}

export async function pauseJob(
  slug: string,
  jobId: string,
): Promise<JobConfig> {
  const res = await apiClient.post<JobConfig>(
    `/projects/${slug}/engine/jobs/${jobId}/pause`,
  );
  return res.data;
}

export async function resumeJob(
  slug: string,
  jobId: string,
): Promise<JobConfig> {
  const res = await apiClient.post<JobConfig>(
    `/projects/${slug}/engine/jobs/${jobId}/resume`,
  );
  return res.data;
}

export async function listRuns(
  slug: string,
  jobId: string,
  page = 1,
  pageSize = 50,
): Promise<JobRunListResponse> {
  const res = await apiClient.get<JobRunListResponse>(
    `/projects/${slug}/engine/jobs/${jobId}/runs`,
    { params: { page, page_size: pageSize } },
  );
  return res.data;
}

export async function getRunDetail(
  slug: string,
  jobId: string,
  runId: number,
): Promise<JobRunDetail> {
  const res = await apiClient.get<JobRunDetail>(
    `/projects/${slug}/engine/jobs/${jobId}/runs/${runId}`,
  );
  return res.data;
}
